import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import Percentage from 'cms/faqs/Article/Policy/Percentage';

const CancelationPolicy = ({companyName, policies, translations}) => {
  const {
    companyCancelPolicy, cancelPolicyOtherDates,
    cancelPolicyDateRange
  } = translations;

  const atLeastNotLowSeason = policies.some(({policy}) => !policy.isLowSeason);

  return (
    <Fragment>
      <div className="font-bold">{companyCancelPolicy.replace('{company}', companyName)}</div>
      {
        policies.map(({percentages, dates, policy: {isLowSeason}}, index) => (
          <Fragment key={index}>
            {
              atLeastNotLowSeason &&
                <div className="my-2">
                  {
                    isLowSeason && atLeastNotLowSeason ? cancelPolicyOtherDates :
                      cancelPolicyDateRange.replace('{date}', dates.join(', '))
                  }
                </div>
            }
            <ul>
              {
                percentages.map(({
                  timeWindowFrameDays,
                  timeWindowFrameHours,
                  refundPercentage,
                  portOfDeparture,
                  portOfArrival,
                  openTicket},
                index) =>
                  <Percentage
                    key={index}
                    timeWindowFrameDays={timeWindowFrameDays}
                    timeWindowFrameHours={timeWindowFrameHours}
                    refundPercentage={refundPercentage}
                    departure={portOfDeparture}
                    arrival={portOfArrival}
                    openTicket={openTicket}
                    translations={translations} />
                )
              }
              {
                percentages.map(({
                  timeWindowFrameDays,
                  timeWindowFrameHours,
                  refundPercentage,
                  locationGroups,
                  openTicket},
                index) =>
                  locationGroups.length > 0 &&
                    <Percentage
                      key={index}
                      timeWindowFrameDays={timeWindowFrameDays}
                      timeWindowFrameHours={timeWindowFrameHours}
                      refundPercentage={refundPercentage}
                      departure={locationGroups}
                      openTicket={openTicket}
                      translations={translations}
                    />
                )
              }
            </ul>
          </Fragment>
        ))
      }
    </Fragment>
  );
};

CancelationPolicy.propTypes = {
  companyName: PropTypes.string.isRequired,
  policies: PropTypes.object.isRequired,
  translations: PropTypes.shape({
    companyCancelPolicy: PropTypes.string.isRequired,
    cancelPolicyOtherDates: PropTypes.string.isRequired,
    cancelPolicyDateRange: PropTypes.string.isRequired
  }).isRequired
};

export default observer(CancelationPolicy);
